const { axiosRequest } = require("./axiosRequest");
const axios = require("axios");

const url = `${process.env.REACT_APP_SERVER_URI}/api/v1/auth`;

let job = null;

const refreshAuth = async () => {
  try {
    const refreshRequest = axios.create({
      baseURL: process.env.REACT_APP_SERVER_URI,
      timeout: 6000,
    });
    let respinosApp = sessionStorage.getItem("respinosApp")
      ? JSON.parse(sessionStorage.getItem("respinosApp"))
      : null;

    if (respinosApp === null) {
      window.location.reload();
      clearInterval(job);
      return null;
    }

    const { data } = await refreshRequest.post(
      "/api/v1/auth/token-refresh",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${respinosApp.refreshToken}`,
        },
      }
    );

    axiosRequest.defaults.headers.Authorization = `Bearer ${data.token}`;

    sessionStorage.setItem(
      "respinosApp",
      JSON.stringify({
        _id: data._id,
        token: data.token,
        refreshToken: data.refresh_token,
      })
    );
  } catch (error) {
    console.log(error.message);
  }
};

const createUpdateTokenJob = () => {
  job = setInterval(() => {
    refreshAuth();
  }, [1000 * 60 * 59]);
};

export const cleanUpdateTokenJob = () => {
  if (job !== null) clearInterval(job);
  job = null;
  // console.log("CLEAN JOB");
};

export const postAuth = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosRequest.post(`${url}/token`, body);
      axiosRequest.defaults.headers.Authorization = `Bearer ${response.data.token}`;

      sessionStorage.setItem(
        "respinosApp",
        JSON.stringify({
          _id: response.data._id,
          token: response.data.token,
          refreshToken: response.data.refresh_token,
        })
      );

      if (job === null) {
        // console.log("CREATE JOB");
        createUpdateTokenJob();
      }

      resolve(response.data);
    } catch (error) {
      error.message = error.response
        ? error.response.data.error
        : error.message;
      reject(error);
    }
  });
};
